<script>
	import { onMount } from 'svelte';
	import Identity from 'svelte-key';
	import { fetchData, generateID, isTouchEnabled } from '../components/shared/utils/Data.svelte';
	import { fly } from 'svelte/transition';
	import Media from '../components/media/Media.svelte';
	import LoginModal from '../components/shared/modal/Login.svelte';
	import Tree from '../components/media/Sidebar.svelte';
	import InfoModal from '../components/shared/modal/Info.svelte';
	
	export let data;
	export let messageToken;
	let tooltips = true;
	let keys = {
		content: "1"
	}
	let sidebar = false;
	let media = {};
	let content = {
        id: "",
        view: ""
    };
	let contentViews = {
		media: Media
	};
	let session = {
    workspaces: []
	};
	let modal = {
		view: ""
	};
	if (localStorage.getItem("session")) {
		session = JSON.parse(localStorage.getItem("session"));
	}
	let modalViews = {
		login: LoginModal,
		info: InfoModal,
	}
	let feature = null;

	onMount(async () => {
		if (!isTouchEnabled) {
			tooltips = false;
		}
		if (data.type && data.uri) {
			media = {
				type: data.type,
				uri: data.uri
			}
			content = {
				id: "1",
				view: "media"
			};
		}
		if (data.feature) {
			feature = data.feature;
			sidebar = true;
			if (session.token) {
				let [res, err] = await fetchData("/v1/session", {
					headers: {
						"Authorization": "Bearer " + session.token,
						"x-message-token": messageToken
					}
				});
				if (err == "invalid or expired jwt") {
					emailAuth()
				}
				else if (!err) {
					session = res.data;
					localStorage.setItem("session", JSON.stringify(session));
				}
			}
			else {
				emailAuth()
			}
		}
  })
	async function emailAuth() {
		let [res, err] = await fetchData("/v1/session/email");
		if (!err) {
			session = res.data;
			localStorage.setItem("session", JSON.stringify(session));
		}
		else {
			modal = {
				view: "login"
			};
		}
	}
	async function messageHandler(message) {
		if (message.detail.type == "session") {
			session = message.detail.data;
			if (!session.token) {
				localStorage.removeItem("session");
				await fetchData("/v1/session/end", {
					headers: {
						"Authorization": "Bearer " + session.token,
						"x-message-token": messageToken
					}
				});
				content = {
					id: "",
					view: ""
				};
				modal = {
					view: "login"
				};
			}
			else {
				localStorage.setItem("session", JSON.stringify(session));
				modal = {
					view: ""
				};
			}
		}
		else if (message.detail.type == "media") {
			var data = message.detail.data;
			console.log(data)
			media = {
				type: data.type,
				uri: data.uri
			}
			keys.content = generateID();
			content = {
				id: "1",
				view: "media"
			};
		}
	}

	function toggleSidebar() {
		sidebar = !sidebar;
	}
</script>

<div class="app off-canvas {sidebar ? "off-canvas-sidebar-show" : ""}">
	{#if modal}
		<svelte:component tooltips={tooltips} this={modalViews[modal.view]} modal={modal} session={session} messageToken={messageToken} on:message={messageHandler} />
	{/if}
	
	<div id="sidebar" class="off-canvas-sidebar {sidebar ? "active" : ""}">
		<div id="toggle-container">
			<button id="toggle" on:click={toggleSidebar} class="btn btn-primary btn-sm">
				<i class="icon {sidebar ? "icon-arrow-left" : "icon-arrow-right"}"></i>	
			</button>
		</div>
		{#if session.token && feature}
			<Tree tooltips={tooltips} feature={feature} media={media} keys={keys} session={session} on:message={messageHandler} />
		{/if}
	</div>
	<div class="off-canvas-content">
		{#if content}
			<Identity key={keys.content}>
				<svelte:component this={contentViews[content.view]} keys={keys} content={content} media={media} on:message={messageHandler} />
			</Identity>
		{/if}
	</div>
</div>

<style>
	#toggle-container {
		position: fixed;
		width: 300px;
	}
	#toggle {
		position: absolute;
		right: 0;
		top: 0.15rem;
		margin-right: -1.4rem;
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
	}
	.app {
		min-height: 100vh;
	}
	.off-canvas-sidebar {
		width: 300px;
	}
	#sidebar {
		overflow: visible;
	}
	.off-canvas .off-canvas-content {
		padding: 0;
	}
</style>